import { OrderTab } from '@src/orders/domain/OrderTab';
import { useOrdersWithFilters } from '@src/orders/hooks/useOrdersWithFilters';

export const useGetActiveOrdersForBillToClient = (
  clientId: string,
  enabled?: boolean,
) => {
  const { orders, isLoading } = useOrdersWithFilters({
    billToClientId: clientId,
    assignedToMe: false,
    page: 1,
    pageSize: 1,
    category: OrderTab.Active,
    enabled,
  });

  return {
    hasActiveOrdersForBillToClient: orders.totalOrders > 0,
    activeOrdersForBillToClientCount: orders.totalOrders,
    isLoading,
  };
};
